import { animated, useSpring } from 'react-spring'
import styled from 'styled-components/macro'

const Message = styled.span`
  color: var(--status-danger);
  font-size: var(--mantine-font-size-xs);
  padding: 0.25rem 0;
`

const Wrap = styled(animated.div)`
  display: inline-flex;
  align-items: center;
  height: 1.4rem;
  text-align: left;
`

export interface ErrorMessageProps {
  children?: string | React.ReactNode
  hideBullet?: boolean
}

/**
 * Used with `Inputs` in an `InputGroup` to notify user of a validation error
 *
 * `Input` should also have ruby border to match `ErrorMessage` color
 * Imported from FlowhubUI
 */
export const InputErrorMessage = ({
  children,
  hideBullet = false,
}: ErrorMessageProps) => {
  const style = useSpring({
    opacity: 1,
    from: { opacity: 0 },
  })
  return (
    <Wrap style={style}>
      {children ? (
        <Message data-test="error_message">
          {hideBullet ? null : '•'} {children}
        </Message>
      ) : null}
    </Wrap>
  )
}
